export default "__VITE_PUBLIC_ASSET__9abe50f6__"